import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // user: null
  },
  mutations: {
    // set_user: (state, user) => state.user = user
  },
  actions: {
    // get_user_login: ({ commit }) => axios.get('backend/getUserLogin').then((resp) => {
    //   if(resp.data.status == 'S') {
    //     commit('set_user', resp.data)
    //   }
    // })
    // get_user_login: ({ commit }) => axios.get('backend/getUserLogin').then(res => commit('set_user', res.data))
      
  },
  modules: {
  }
})
